import GenericButton from "@/components/forms/inputs/button/genericButton";
import RoundedContentBox from "@/components/general/roundedContentBox";
import { LinearProgress } from "@mui/material";

interface Props {
  count: number;
  title: string;
  buttonLabel?: string;
  onClick?: () => void;
  description?: string;
  secondaryButtonLabel?: string;
  secondaryButtonStartIcon?: React.ReactNode;
  onSecondaryClick?: () => void;
  progressPercent?: number;
  progressText?: string;
}

export default function LmsSummaryCard({
  count,
  title,
  buttonLabel,
  onClick,
  description,
  secondaryButtonLabel,
  secondaryButtonStartIcon,
  onSecondaryClick,
  progressPercent,
  progressText,
}: Props) {
  const normalizedProgressPercent =
    progressPercent === undefined
      ? undefined
      : Math.max(0, Math.min(100, progressPercent));
  const primaryAction = buttonLabel && onClick ? (
    <GenericButton
      onClick={onClick}
      style={{ width: "100%", justifyContent: "center" }}
    >
      {buttonLabel}
    </GenericButton>
  ) : null;
  const secondaryAction = secondaryButtonLabel && onSecondaryClick ? (
    <GenericButton
      variant="outlined"
      color="tertiary"
      startIcon={secondaryButtonStartIcon}
      onClick={onSecondaryClick}
      style={{ width: "100%", justifyContent: "center" }}
    >
      {secondaryButtonLabel}
    </GenericButton>
  ) : null;

  return (
    <RoundedContentBox
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div>
        <p
          style={{
            fontSize: "3.5rem",
            fontWeight: 700,
            color: "#8c1ec8",
            margin: 0,
            lineHeight: 1,
          }}
        >
          {count}
        </p>
        <h3
          style={{
            margin: "1rem 0 0 0",
            fontSize: "1.25rem",
            fontWeight: 600,
          }}
        >
          {title}
        </h3>
        {description && (
          <p
            style={{
              margin: "1.25rem 0 0",
              fontWeight: 600,
              color: "#4a4a4a",
            }}
          >
            {description}
          </p>
        )}
      </div>
      {normalizedProgressPercent !== undefined && (
        <div style={{ marginTop: "1.25rem", marginBottom: "1rem" }}>
          {progressText && (
            <p
              style={{
                margin: "0 0 0.5rem 0",
                fontWeight: 600,
                color: "#4a4a4a",
              }}
            >
              {progressText}
            </p>
          )}
          <LinearProgress
            variant="determinate"
            value={normalizedProgressPercent}
            color="secondary"
            sx={{ height: 10, borderRadius: 999, backgroundColor: "#ebe4f2" }}
          />
        </div>
      )}
      {primaryAction && secondaryAction ? (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          {primaryAction}
          {secondaryAction}
        </div>
      ) : (
        (primaryAction ?? secondaryAction)
      )}
    </RoundedContentBox>
  );
}
